import { getWomanThumbImageUrl } from "../../../utils/imageUrl";
import { useTranslation } from "../../../i18n/LanguageProvider";
import ResponsiveAdSection from "../../../Components/ResponsiveAdSection/ResponsiveAdSection";
import { AD_SLOTS } from "../../../config/adSlots";
import WomanCard from "../../Home/Components/WomanCard/WomanCard";

function RelatedWomenSidebar({ women, loading }) {
    const { t } = useTranslation();

    return (
        <aside className="woman-page__sidebar" aria-labelledby="related-women-title">
            <h2 id="related-women-title" className="woman-page__sidebar-title">
                {t("profile.related")}
            </h2>

            {loading ? (
                <p className="woman-page__empty">{t("profile.loading")}</p>
            ) : women.length > 0 ? (
                <div className="woman-page__related-list">
                    {women.map((woman) => (
                        <WomanCard
                            key={woman.id}
                            id={woman.id}
                            name={woman.name}
                            surname={woman.surname}
                            domain={woman.category_name}
                            categoryColor={woman.category_color}
                            image={getWomanThumbImageUrl(woman.image)}
                        />
                    ))}
                </div>
            ) : (
                <p className="woman-page__empty">{t("profile.noRelated")}</p>
            )}

            {!loading && women.length > 0 && (
                <ResponsiveAdSection
                    adSlot={AD_SLOTS.displayInline}
                    className="woman-page__related-mobile-ad"
                />
            )}
        </aside>
    );
}

export default RelatedWomenSidebar;
